@if (chartOptions) {
  <apx-chart
    [chart]="chartOptions.chart!"
    [colors]="colors"
    [fill]="chartOptions.fill!"
    [dataLabels]="chartOptions.dataLabels!"
    [stroke]="chartOptions.stroke!"
    [plotOptions]="chartOptions.plotOptions!"
    [grid]="chartOptions.grid!"
    [series]="chartOptions.series!"
    [xaxis]="chartOptions.xaxis!"
  >
  </apx-chart>
}
